import {useAppStore} from '@/stores'
import {useEventBus} from '@vueuse/core'

export const showChangingStrategy = () => {
  useAppStore().loading('Please wait, we are changing the session configuration')
}

export const useChangeStrategyCallback = () => {
  const appStore = useAppStore()

  useEventBus('strategy:changed').on(() => {
    appStore.loaded()
  })
}
